// @core/api/endpoints/fiscalization/list_fiscal_providers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFiscalProvidersResponse,
} from '../../../types/fiscalization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/fiscalization';

/**
 * List fiscal providers
 * Returns a paginated list of fiscal provider configurations with optional filtering by type, country, or status.
 */
export async function ListFiscalProviders(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFiscalProvidersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-providers`;
  const requestOptions = options;
  return client.get<ListFiscalProvidersResponse>(requestPath, { ...requestOptions, params });
}
